import { render, staticRenderFns } from "./Table2Container.vue?vue&type=template&id=13cc924e&"
import script from "./Table2Container.vue?vue&type=script&lang=js&"
export * from "./Table2Container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports